<template v-show="openned">
  <v-dialog
    scrollable
    v-model="dialog"
    persistent
    :fullscreen="fullscreen"
    overlay-opacity="0.6"
    overlay-color="#000000"
    :width="size_"
    :height="height"
    transition="false"
    content-class="kalan-dialog">
    <v-card style="min-height: 650px" :color="color">
      <v-toolbar fixed flat color="transparent" dark class="kalan-dialog__header">
        <v-toolbar-title class="kalan-dialog__title">
          {{title}}
          <div class="kalan-dialog__subtitle" v-if="subtitle || $slots.subtitle">
            <slot name="subtitle" v-if="$slots.subtitle"></slot>
            <template v-else-if="subtitle">{{subtitle}}</template>
          </div>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="kalan-dialog__actions" ref="actions">
          <template v-for="( action, indexAction ) in (actions || [])">
            <template v-if="(action.condition ? action.condition() : true)">
              <v-tooltip top :key="indexAction">
                <template v-slot:activator="{ on }">
                  <button
                    v-on="on"
                    type="button"
                    class="kalan-dialog__action-btn"
                    :class="'is-' + getIntent(action)"
                    @click="runAction(action)"
                  >
                    <v-icon v-if="action.icon" size="18" v-html="action.icon" />
                    <span v-if="action.title || action.text">{{action.title || action.text}}</span>
                  </button>
                </template>
                <span>{{ action.help || '' }}</span>
              </v-tooltip>
            </template>
          </template>
          <button
            type="button"
            class="kalan-dialog__action-btn is-close"
            @click="close"
          >
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </div>
      </v-toolbar>
      <v-card-text>
        <div ref="dialog_body" :id="id"></div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    size: String,
    height: String,
    color: String,
    fullscreen: {
      type: Boolean,
      default: false
    },
    title: String,
    titleColor: {
      type: String,
      default: 'primary'
    },
    subtitle: String,
    onClose: Function,
    actions: Array,
  },
  beforeCreate() {
    if (this.$vuetify.breakpoint.smAndDown) {
      document.getElementsByTagName('body')[0].className = 'noscroll';
    }
  },
  beforeDestroy() {
    document.body.removeAttribute('class', 'noscroll');
  },
  data: () => ({
    dialog: true,
    openned: false,
    id: new Date().getTime(),
    sizes: {
      small: '400px',
      medium: '700px',
      large: '900px',
      'x-large': '90%',
      xl: '90%',
    }
  }),
  methods: {
    open() {
      this.openned = true
    },
    close() {
      if (this.onClose) {
        this.onClose()
      }
      this.$destroy()
    },
    clean() {
      this.$refs.dialog_body.firstChild.remove()
    },
    runAction(action) {
      action.action()
    },
    getIntent(action) {
      if (action.intent) return action.intent
      const icon = action.icon || ''
      if (icon === 'mdi-content-save' || icon === 'mdi-check') return 'save'
      if (icon === 'mdi-delete' || icon === 'mdi-delete-outline' || icon === 'mdi-trash-can') return 'delete'
      if (icon === 'mdi-plus' || icon === 'mdi-plus-circle') return 'create'
      return 'default'
    },
  },
  computed: {
    size_() {
      return this.sizes[this.size ? this.size : 'medium']
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  background: var(--kln-bg-surface) !important;
}

.v-card__text {
  height: 100% !important;
  padding: unset !important;
}

.kalan-dialog__header {
  border-bottom: 1px solid var(--kln-border-dim) !important;
}

.kalan-dialog__header ::v-deep .v-toolbar__content {
  padding: 0 16px !important;
}

.kalan-dialog__title {
  color: var(--kln-text) !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  letter-spacing: 0.01em;
}

.kalan-dialog__subtitle {
  font-size: 11px;
  color: var(--kln-text-dim);
  font-weight: 400;
  margin-top: 2px;
}

.kalan-dialog__actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.kalan-dialog__action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  min-width: 32px;
  padding: 0 10px;
  background: var(--kln-border-dim);
  border: 1px solid var(--kln-border-normal);
  border-radius: 6px;
  color: var(--kln-text-muted);
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.kalan-dialog__action-btn:hover {
  background: var(--kln-bg-overlay);
  color: var(--kln-text);
}

.kalan-dialog__action-btn .v-icon {
  color: inherit !important;
}

.kalan-dialog__action-btn.is-save,
.kalan-dialog__action-btn.is-confirm {
  background: rgba(61, 154, 110, 0.15);
  border-color: rgba(61, 154, 110, 0.4);
  color: #5BB988;
}

.kalan-dialog__action-btn.is-save:hover,
.kalan-dialog__action-btn.is-confirm:hover {
  background: rgba(61, 154, 110, 0.25);
  color: #7ED6A3;
}

.kalan-dialog__action-btn.is-create {
  background: rgba(124, 109, 240, 0.15);
  border-color: rgba(124, 109, 240, 0.4);
  color: #9588F0;
}

.kalan-dialog__action-btn.is-create:hover {
  background: rgba(124, 109, 240, 0.25);
  color: #B4A9FF;
}

.kalan-dialog__action-btn.is-delete,
.kalan-dialog__action-btn.is-danger {
  background: rgba(176, 80, 80, 0.15);
  border-color: rgba(176, 80, 80, 0.4);
  color: #D17070;
}

.kalan-dialog__action-btn.is-delete:hover,
.kalan-dialog__action-btn.is-danger:hover {
  background: rgba(176, 80, 80, 0.25);
}

.kalan-dialog__action-btn.is-close:hover {
  background: rgba(176, 80, 80, 0.12);
  border-color: rgba(176, 80, 80, 0.3);
  color: #D17070;
}


</style>

<!-- Overrides globales para el tema claro. Los botones de acción usan colores pastel
     (#5BB988, #9588F0, #D17070) calibrados para fondos dark. Sobre --kln-bg-surface
     blanco (diurno) esos pastel fallan WCAG AA (≤3.35:1). Selector de mayor
     especificidad con data-theme para sobreescribir el scoped sin !important. -->
<style lang="scss">
[data-theme="diurno"] .kalan-dialog__action-btn.is-save,
[data-theme="diurno"] .kalan-dialog__action-btn.is-confirm {
  color: #1E6E48;
}
[data-theme="diurno"] .kalan-dialog__action-btn.is-save:hover,
[data-theme="diurno"] .kalan-dialog__action-btn.is-confirm:hover {
  color: #2E7A55;
}
[data-theme="diurno"] .kalan-dialog__action-btn.is-create {
  color: #5040A0;
}
[data-theme="diurno"] .kalan-dialog__action-btn.is-create:hover {
  color: #6350C8;
}
[data-theme="diurno"] .kalan-dialog__action-btn.is-delete,
[data-theme="diurno"] .kalan-dialog__action-btn.is-danger {
  color: #A0291C;
}
[data-theme="diurno"] .kalan-dialog__action-btn.is-delete:hover,
[data-theme="diurno"] .kalan-dialog__action-btn.is-danger:hover {
  color: #C03030;
}
[data-theme="diurno"] .kalan-dialog__action-btn.is-close:hover {
  color: #A0291C;
}
</style>
